import { render, staticRenderFns } from "./PlanEdit.vue?vue&type=template&id=2da91550&scoped=true&"
import script from "./PlanEdit.vue?vue&type=script&lang=js&"
export * from "./PlanEdit.vue?vue&type=script&lang=js&"
import style0 from "./PlanEdit.vue?vue&type=style&index=0&id=2da91550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da91550",
  null
  
)

export default component.exports